<template>
  <div class="wwf-content" ref="stepup">
    <div class="header">
      <h2 class="title">{{ title.toUpperCase() }}</h2>
      <button class="popup-close-button" data-close type="button">
        <span class="popup-close-button-span">&times;</span>
      </button>
    </div>
    <div class="threatened-species-popup-content" v-html="content"></div>

    <!-- Share -->
    <div class="ls-ty-share">
      <p>Share</p>
    </div>

    <div class="gs-wrapper">
      <div class="getsocial gs-inline-group"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "threatened-species-thank-you-popup",

  props: {
    title: {
      type: String,
    },
    content: {
      type: String,
    },
    // Use amplitude to track or not
    isAmplitude: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    // Attach amplitude event to hyperlink button in content
    const stepupButton = this.$refs.stepup.querySelector("a");
    if (this.isAmplitude) { 
      try {
        $(stepupButton).click({ callback: this.handleClick }, function (e) {
          e.preventDefault();
          e.data.callback(this.href);
        });
      } catch (err) {
        console.error(err);
      }
    } 

    // Change style for just this component so it doesn't affect other popups
    $(".reveal-overlay").css({
      "background-color": "#1c3226",
      overflow: "hidden",
    });
    
    // Reload get socials
    if (GS) {
      GS.reset();
    }
  },

  methods: {
    // handleClose() {
    //   this.$store.dispatch("logStepUpDeclined");
    // },

    handleClick(link) {
      const stepupButton = this.$refs.stepup.querySelector("a");
      try {
        const text = $(stepupButton).text();
        this.$store
          .dispatch("logSimpleEvent", {
            eventName: "Step Up Actioned",
            eventProperties: {
              "Step Up Actioned": true,
              "Page path": link,
              "Button text": text,
            },
          })
          .then(() => (window.location.href = link));
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
/* WWF */
.wwf-content {
  text-align: center;
  color: var(--wwfWhite);
  width: 100%;
  height: 100%;
  max-width: 1250px;
  margin-top: 1rem;
}

.title {
  width: 99%;
}

#reveal-popup-custom-content .wwf-content .header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 2rem;
}

.threatened-species-popup-content >>> .threatened-species-redirect {
  background-color: var(--wwfRegenerateAustralia);
}

.ls-ty-share {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>


// WEBPACK FOOTER //
// ThankYouPopup.vue?6e755e0b